<template>
<body style="background-color:#D6D6D6">
    <div id="planeaciones1k">

        <v-container>
            <!--<h1 class="pl-5 ml-4 pt-5" style="color:#942C75; font-family:Poppins; font-size:1.8vw; font-weight:500">{{title}}</h1>-->
            
            <!--<v-layout justify-center>
            <img class="hidden-xs-only" src="1K.png" >
            <img class="hidden-sm-and-up" src="1K.png" width="300px" height="79px">
            </v-layout>-->    

            
            
            <ContentRead  portada="1K.png" :files="planeaciones1k">       
            </ContentRead>
            <!--<br><br><br><br><br><br><br>-->
       </v-container>
         

    </div>
    </body>
</template>


<script>
import ContentRead from "@/components/ContentRead.vue"

export default {
   
    components:{
       ContentRead
     },

    data(){
        return{
            title:"PLANEACIONES 1K",
            planeaciones1k:[
          
          //{title:"Planeación Semana 1",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1_1K_VD.pdf",namedownload:"1k_Semana1"},
          {title:"Planeación Semana 1",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana1.pdf",namedownload:"1k_Semana1"},
          {title:"Planeación Semana 2",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana2.pdf",namedownload:"1k_Semana2"},
          {title:"Planeación Semana 3",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana3.pdf",namedownload:"1k_Semana3"},
          {title:"Planeación Semana 4",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana4.pdf",namedownload:"1k_Semana4"},
          {title:"Planeación Semana 5",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana5.pdf",namedownload:"1k_Semana5"},
          {title:"Planeación Semana 6",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana6.pdf",namedownload:"1k_Semana6"},
          {title:"Planeación Semana 7",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana7.pdf",namedownload:"1k_Semana7"},
          {title:"Planeación Semana 8",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana8.pdf",namedownload:"1k_Semana8"},
          {title:"Planeación Semana 9",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana9.pdf",namedownload:"1k_Semana9"},
          {title:"Planeación Semana 10",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana10.pdf",namedownload:"1k_Semana10"},
          {title:"Planeación Semana 11",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana11.pdf",namedownload:"1k_Semana11"},
          {title:"Planeación Semana 12",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana12.pdf",namedownload:"1k_Semana12"},
          {title:"Planeación Semana 13",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana13.pdf",namedownload:"1k_Semana13"},
          {title:"Planeación Semana 14",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana14.pdf",namedownload:"1k_Semana14"},
          {title:"Planeación Semana 15",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana15.pdf",namedownload:"1k_Semana15"},
          {title:"Planeación Semana 16",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana16.pdf",namedownload:"1k_Semana16"},
          {title:"Planeación Semana 17",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana17.pdf",namedownload:"1k_Semana17"},
          {title:"Planeación Semana 18",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana18.pdf",namedownload:"1k_Semana18"},
          {title:"Planeación Semana 19",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana19.pdf",namedownload:"1k_Semana19"},
          {title:"Planeación Semana 20",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana20.pdf",namedownload:"1k_Semana20"},
          {title:"Planeación Semana 21",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana21.pdf",namedownload:"1k_Semana21"},
          {title:"Planeación Semana 22",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana22.pdf",namedownload:"1k_Semana22"},
          {title:"Planeación Semana 23",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana23.pdf",namedownload:"1k_Semana23"},
          {title:"Planeación Semana 24",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana24.pdf",namedownload:"1k_Semana24"},
          {title:"Planeación Semana 25",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana25.pdf",namedownload:"1k_Semana25"},
          {title:"Planeación Semana 26",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana26.pdf",namedownload:"1k_Semana26"},
          {title:"Planeación Semana 27",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana27.pdf",namedownload:"1k_Semana27"},
          {title:"Planeación Semana 28",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana28.pdf",namedownload:"1k_Semana28"},
          {title:"Planeación Semana 29",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana29.pdf",namedownload:"1k_Semana29"},
          {title:"Planeación Semana 30",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana30.pdf",namedownload:"1k_Semana30"},
          {title:"Planeación Semana 31",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana31.pdf",namedownload:"1k_Semana31"},
          {title:"Planeación Semana 32",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana32.pdf",namedownload:"1k_Semana32"},
          {title:"Planeación Semana 33",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana33.pdf",namedownload:"1k_Semana33"},
          {title:"Planeación Semana 34",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana34.pdf",namedownload:"1k_Semana34"},
          {title:"Planeación Semana 35",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana35.pdf",namedownload:"1k_Semana35"},
          {title:"Planeación Semana 36",img:"blanco.png",url:"../descargas/files/planeaciones/1k/Planeacion1k_Semana36.pdf",namedownload:"1k_Semana36"},
        ]
        }
    },
}
</script>

<style scoped>

</style>


